/* eslint-disable */

import React from "react";

function Header() {
  return (
    <header className="header">
      <h1>Cash Register Manager App</h1>
    </header>
  );
}
export default Header;
